function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_material-location-on",
  "data-name": "Icon material-location-on",
  d: "M14.671,3A7.165,7.165,0,0,0,7.5,10.171c0,5.378,7.171,13.317,7.171,13.317s7.171-7.939,7.171-13.317A7.165,7.165,0,0,0,14.671,3Zm0,9.732a2.561,2.561,0,1,1,2.561-2.561A2.562,2.562,0,0,1,14.671,12.732Z",
  transform: "translate(-7 -2.5)",
  fill: "none",
  stroke: "#222222",
  strokeWidth: 1
});

var SvgAddress = function SvgAddress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Location",
    width: 15.341,
    height: 21.734,
    viewBox: "0 0 15.341 21.734",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/address.d5ff9de2.svg";
export { ForwardRef as ReactComponent };